import { Component } from '@angular/core';

@Component({
  selector: 'about-thinning',
  templateUrl: 'about-thinning.html'
})
export class AboutThinningPage {
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/pages/about-thinning/about-thinning.ts